import { render, staticRenderFns } from "./MenuItemWithExtras.vue?vue&type=template&id=af3d0d8e&scoped=true"
import script from "./MenuItemWithExtras.vue?vue&type=script&lang=js"
export * from "./MenuItemWithExtras.vue?vue&type=script&lang=js"
import style0 from "./MenuItemWithExtras.vue?vue&type=style&index=0&id=af3d0d8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3d0d8e",
  null
  
)

export default component.exports